import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { ProductLeafNodeData } from './canvas-types';
import styles from './product-leaf-node.module.css';

export const ProductLeafNode = memo(({ data, selected }: NodeProps) => {
  const { name, price } = data as ProductLeafNodeData;
  const formattedPrice = (price / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <div className={`${styles.node} ${selected ? styles.selected : ''}`}>
      <Handle type="target" position={Position.Top} className={styles.targetHandle} />
      <div className={styles.name}>{name}</div>
      <div className={styles.price}>{formattedPrice}</div>
    </div>
  );
});

ProductLeafNode.displayName = 'ProductLeafNode';
